export const numToChinese = {
	1: '一',
	2: '二',
	3: '三'
}

export const studentStatus = [
  { val: 0, name: '未入学' },
  { val: 1, name: '就读' },
  { val: 2, name: '毕业' },
  // { val: 3, name: '转校' }
]
